import React from "react";

export const orderStatus = {
  assigned: {
    name: 'ASSIGNED',
    textColor: '#1DBD6B',
    background: '#E8F8F0',
    icon: (
      <svg width="13" height="13" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.294 5.29105C13.294 8.22808 10.9391 10.5831 8 10.5831C5.0619 10.5831 2.70601 8.22808 2.70601 5.29105C2.70601 2.35402 5.0619 0 8 0C10.9391 0 13.294 2.35402 13.294 5.29105ZM8 20C3.66237 20 0 19.295 0 16.575C0 13.8539 3.68538 13.1739 8 13.1739C12.3386 13.1739 16 13.8789 16 16.599C16 19.32 12.3146 20 8 20Z" fill="#1DBD6B" />
      </svg>
    )
  },
  unassigned: {
    name: 'UNASSIGNED',
    textColor: '#1DBD6B',
    background: '#E8F8F0',
    icon: (
      <svg width="13" height="13" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.00586 10.5537C10.7604 10.5537 12.9685 8.31705 12.9685 5.52684C12.9685 2.73663 10.7604 0.5 8.00586 0.5C5.25129 0.5 3.04323 2.73663 3.04323 5.52684C3.04323 8.31705 5.25129 10.5537 8.00586 10.5537ZM8.00586 13.0152C3.96008 13.0152 0.505859 13.6621 0.505859 16.2464C0.505859 18.8298 3.93906 19.5 8.00586 19.5C12.0506 19.5 15.5059 18.8531 15.5059 16.2687C15.5059 13.6844 12.0727 13.0152 8.00586 13.0152ZM17.4958 7.21986L18.3465 6.36915C18.6966 6.01899 19.2717 6.02301 19.6267 6.3781C19.9818 6.73318 19.9858 7.30821 19.6357 7.65838L18.785 8.50908L19.6174 9.34155C19.9725 9.69664 19.9773 10.2709 19.6264 10.6218C19.2762 10.972 18.7012 10.968 18.3461 10.6129L17.5136 9.78042L16.6644 10.6297C16.3135 10.9806 15.7392 10.9758 15.3841 10.6207C15.029 10.2656 15.0243 9.69135 15.3752 9.34046L16.2244 8.4912L15.3927 7.65947C15.0376 7.30438 15.0336 6.72935 15.3837 6.37919C15.7346 6.0283 16.3089 6.03304 16.664 6.38813L17.4958 7.21986Z" fill="#1DBD6B" />
      </svg>
    )
  },
  completed: {
    name: 'COMPLETED',
    textColor: '#1DBD6B',
    background: '#E8F8F0',
    icon: (
      <svg width="13" height="13" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.67 0H14.34C17.73 0 20 2.38 20 5.92V14.091C20 17.62 17.73 20 14.34 20H5.67C2.28 20 0 17.62 0 14.091V5.92C0 2.38 2.28 0 5.67 0ZM9.43 12.99L14.18 8.24C14.52 7.9 14.52 7.35 14.18 7C13.84 6.66 13.28 6.66 12.94 7L8.81 11.13L7.06 9.38C6.72 9.04 6.16 9.04 5.82 9.38C5.48 9.72 5.48 10.27 5.82 10.62L8.2 12.99C8.37 13.16 8.59 13.24 8.81 13.24C9.04 13.24 9.26 13.16 9.43 12.99Z" fill="#1DBD6B" />
      </svg>

    )
  },
  cancelled: {
    name: 'CANCELLED',
    textColor: '#FD2020',
    background: '#FFF4F4',
    icon: (
      <svg width="13" height="13" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.67 -0.000976562H14.34C17.73 -0.000976562 20 2.37902 20 5.91902V14.09C20 17.62 17.73 19.999 14.34 19.999H5.67C2.28 19.999 0 17.62 0 14.09V5.91902C0 2.37902 2.28 -0.000976562 5.67 -0.000976562ZM13.01 12.999C13.35 12.66 13.35 12.11 13.01 11.77L11.23 9.99002L13.01 8.20902C13.35 7.87002 13.35 7.31002 13.01 6.97002C12.67 6.62902 12.12 6.62902 11.77 6.97002L10 8.74902L8.22 6.97002C7.87 6.62902 7.32 6.62902 6.98 6.97002C6.64 7.31002 6.64 7.87002 6.98 8.20902L8.76 9.99002L6.98 11.76C6.64 12.11 6.64 12.66 6.98 12.999C7.15 13.169 7.38 13.26 7.6 13.26C7.83 13.26 8.05 13.169 8.22 12.999L10 11.23L11.78 12.999C11.95 13.18 12.17 13.26 12.39 13.26C12.62 13.26 12.84 13.169 13.01 12.999Z" fill="#FD2020" />
      </svg>

    )
  }
};